import React from 'react';
import root from 'window-or-global';
import Message from '../common/Message';
import getCurrentLocale from '../../utils/Utils';
import {Icon, svgs} from 'epic-diesel-common';
import {getDataAttribute, getWindowLocationOrigin} from 'epic-common/src/browser';
import {LocalizationProps} from 'epic-localization';
import {withLocalization} from 'epic-localization/src/context/LocalizationContext';

//@ts-ignore
import styles from './Locale.pcss';

interface SupportedLocale extends Unpack<LocalizationProps['supportedLocales']> {
    onClick?: (e?) => void;
}

export interface LocaleProps extends LocalizationProps {
    supportedLocales: SupportedLocale[];
}

const Locale = ({messages, getMessage, supportedLocales, locale: selectedLocale}: LocaleProps) => {
    if (!supportedLocales || !supportedLocales.length || supportedLocales.length === 1) {
        console.warn('SupportedLocales array was invalid or empty. Hiding locale...');
        return null;
    }

    const {currentLocale, locales} = getCurrentLocale(
        supportedLocales,
        selectedLocale,
        messages['locale']
    );

    const onClick = e => {
        const index = getDataAttribute(e.currentTarget, 'index');
        if (index) {
            const locale = supportedLocales[index];
            if (locale && locale.onClick && typeof locale.onClick === 'function') {
                locale.onClick(e);
            }
        }
    };

    const getHref = (locale: SupportedLocale) => {
        const lang = locale.lang.replace(/_/, '-');
        let url = getWindowLocationOrigin() + root.location.pathname + root.location.search;

        if (url.indexOf('lang=') > -1) {
            url = url.replace(/lang=[\w_-]*/, `lang=${lang}`);
        } else if (url.indexOf('?') > -1) {
            url += `&lang=${lang}`;
        } else {
            url += `?lang=${lang}`;
        }

        return url + root.location.hash;
    };

    return (
        <div id="locale" className={styles.locale}>
            <div className={styles.icon} title={getMessage(currentLocale)}>
                <Icon icon={svgs.SPHERE} />
            </div>
            <ul>
                {locales.map((item, i) => {
                    if (!item.lang || !item.name) {
                        if (process.env.NODE_ENV !== 'production') {
                            console.warn(
                                `locale [${selectedLocale}] had an invalid [${item.name}] or [${item.lang}]! Ensure that the localeOptions are correct.`
                            );
                        }
                        return null;
                    }

                    if (item.lang === selectedLocale) {
                        return null;
                    }

                    const lang = item.lang.replace(/_/, '-');
                    return (
                        <li key={`lang-${lang}`} data-lang={lang}>
                            <a
                                href={getHref(item)}
                                onClick={onClick}
                                data-index={i}
                                className="text-color-hover text-color-nonactive">
                                <Message code={item.name} />
                            </a>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default withLocalization(Locale);
